
import { List, Card, Space } from "antd";
import React from "react";
import { priceTypes, pricingCategory } from "../../enums/pricing.enum";
import { useSearchParams } from "react-router-dom";

const currencyDisplay = (currency, value) => {
  const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency})
  return formatter.format(value)
}

const PriceDetails = (
  props: {
    priceCurrency:string,
    prices: any[],
    roomTypes?: Record<string, string>
  }
) => {
  const { priceCurrency, prices, roomTypes } = props;
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const categories = pricingCategory(roomTypes || type || undefined)
  
  var pricingTypes:any[] = [], priceTable:any = {}, priceList:any[] = [];
  if(prices.length>0){
    pricingTypes = prices.map((price:any) => price.type);
    prices.forEach((price:any) => {
      const pricingObj = {
        label: price.display_price,
        adult: price.adult,
        child_no_bed: price.child_no_bed,
        child_twin: price.child_twin,
        child_with_bed: price.child_with_bed,
        dta_adult: price.dta_adult,
        dta_child_no_bed: price.dta_child_no_bed,
        dta_child_twin: price.dta_child_twin,
        dta_child_with_bed: price.dta_child_with_bed,
        dta_infant: price.dta_infant,
        dta_single_supplement: price.dta_single_supplement,
        infant: price.infant,
        single_supplement: price.single_supplement,
      };

      priceTable[price.type] = pricingObj;

      priceList.push({
        title: `${price.display_price} ${priceTypes[price.type]}`,
        type: price.type,
        ...pricingObj
      })
    });
  }

  const priceLabel = (price) => price == 0 ? "TBC" : currencyDisplay(priceCurrency, price);

  return (
    <div id="price-details" className="details-container">
      <div className="details-container_header"> Price Details </div>
      <div className="details-container_content">
        <table id="pricing-table">
          <thead>
            <tr>
              <th></th>
              {
                pricingTypes.map((type:any, index) => <th key={index} className={type}>
                  <div>{priceTable[type].label}</div>
                  <div className="price-type">{priceTypes[type]}</div>
                </th>)
              }
            </tr>
          </thead>
          <tbody>
            {
              Object.entries(categories).map(category => (
                <tr key={category[0]}>
                  <td> {category[1] as string}  </td>
                  {
                    pricingTypes.map((type:any, index) => {
                      const price = priceTable[type][category[0]];
                      return <td key={index} className={type}> { priceLabel(price) }</td>
                    })
                  }
                </tr>
              ))
            }
          </tbody>
        </table>

        {
          priceList.length > 0 && (
            <List
              id="pricing-list"
              itemLayout="vertical"
              dataSource={priceList}
              renderItem={(item) => (
                <List.Item>
                  <Card className={item.type}>
                    <div className="pricing-header"> {item.title} </div>
                    <div className="pricing-body"> 
                      <Space size={15} direction="vertical" style={{display: 'flex'}}>
                        {
                          Object.entries(categories).map(category => {
                            const price = item[category[0]];
                            return (
                              <div key={category[0]} className="pricing"> 
                                <div className="category"> {category[1] as string} </div>
                                <div className="price">{ priceLabel(price) }</div>
                              </div>
                            )
                          })
                        }
                      </Space>
                    </div>
                  </Card>
                </List.Item>
              )}
            />
          )
        }

      </div>
    </div>
  )
}

export default PriceDetails;